<div class="header">
  <h3 class="title">
    <div class="mobile-prefix">
      <a
        tabindex="0"
        class="mobile-back-button"
        ixTest="disk-details-back"
        (click)="onCloseMobileDetails()"
        (keydown.enter)="onCloseMobileDetails()"
      >
        <ix-icon name="mdi-chevron-left"></ix-icon>
      </a>
      {{ 'Details for' | translate }}
    </div>

    <span class="prefix">{{ 'Details for' | translate }}</span>

    <div class="full-path">
      <ix-topology-item-icon
        class="title-icon"
        [topologyItem]="topologyItem"
        [disk]="disk"
      ></ix-topology-item-icon>
      <span class="device-name">{{ title }}</span>
    </div>
  </h3>
</div>

<div class="cards">
  <div class="cards-column scroll-window">
    <ix-zfs-info-card
      [topologyItem]="topologyItem"
      [disk]="disk"
      [topologyParentItem]="topologyParentItem"
      [poolId]="poolId"
      [topologyCategory]="topologyCategory"
      [hasTopLevelRaidz]="hasTopLevelRaidz"
    ></ix-zfs-info-card>

    <ng-container *ngIf="isTopologyDisk && hasTopologyItemDisk">
      <ix-hardware-disk-encryption
        [topologyDisk]="topologyItem | cast"
      ></ix-hardware-disk-encryption>

      <ix-smart-info-card
        [topologyDisk]="topologyItem | cast"
        [disk]="disk"
      ></ix-smart-info-card>
    </ng-container>

    <ng-container *ngIf="isTopologyDisk">
      <ix-disk-info-card
        [topologyDisk]="topologyItem | cast"
        [disk]="disk"
      ></ix-disk-info-card>
    </ng-container>
  </div>
</div>
